import commonService from '@/backend/services/base/commonService'
import caseService from '@/backend/services/case/caseService'
import apiConfig from '@/backend/apiConfig/apiConfig'
import OSS from 'ali-oss'

const state = {
  ossAK: [],
  ossClient: ''
}

const getters = {
  menus: state => state.data
}

const mutations = {
  updateOssAK (state, data) {
    state.ossAK = data
  },
  updateOssClient (state, data) {
    state.ossClient = data
  }
}

const actions = {
  async update (context, isPrivate) {
    let result = await commonService({
      api: apiConfig.case.getTokenApi,
      type: 'Get'
    }).querying();
    context.commit('updateOssAK', result)
    const client = new OSS.Wrapper({
      endpoint: result.data.endpoint,
      accessKeyId: result.data.accessKeyId,
      accessKeySecret: result.data.accessKeySecret,
      stsToken: result.data.securityToken,
      bucket: isPrivate ? _.find(result.data.bucketName, function(item) { return item.code === isPrivate }).name : _.find(result.data.bucketName, function(item) { return item.code === 4 }).name
    })
    context.commit('updateOssClient', client)
  },
  upload (context, fileObj) {
    let a = fileObj.name.split('.')[fileObj.name.split('.').length - 1];
    let b = Buffer.from(fileObj.name.split(a)[0]).toString('base64') + '.' + a;
    return context.state.ossClient.multipartUpload(b, fileObj, {
      progress: function* (percentage, cpt) {
        // 上传进度
        fileObj.callback(percentage * 100)
      }
    })
  },
  async getList (context, fileObj) {
    if(!context.state.ossClient){
      await context.dispatch('update')
    }
    return context.state.ossClient.list(fileObj).then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      return Promise.reject(err)
    })
  },
  async getUrl (context, fileName) {
    !(function(W){
      W.Base64 = {
        utf8ToBase64: function (str){
          return btoa(unescape(encodeURIComponent(str)));
        },
        base64ToUtf8: function(str){
          return decodeURIComponent(escape(atob(str)));
        }
      }
    }(window));
    fileName = Base64.utf8ToBase64(fileName)
    let result = await caseService.getUrl(fileName)
    return result.data.result
  },
  async delete (context, objectKey) {
    if(!context.state.ossClient){
      await context.dispatch('update')
    }
    return context.state.ossClient.delete(objectKey).then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      return Promise.reject(err)
    })
  },
  async getSignatureUrl(context, objectKey){
    if(!context.state.ossClient){
      await context.dispatch('update')
    }
    let url = context.state.ossClient.signatureUrl(objectKey);
    return url
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
